import React from 'react';
import { ContentSection, Spinner } from '@vwfs-bronson/bronson-react';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../redux/store';
import { getRequestInfoType, getSession, getTransactionStatus } from '../../redux/slices/appData/app-data.selectors';
import { validateLegitimationResult } from '../../redux/slices/appData/app-data.actions';
import { TransactionStatus } from '../../models/data-storage.model';
import { routeByStatus } from '../../routes';

/**
 * Handles callback from the Onfido legitimation page.
 */
export const LegitimationRedirectPage: React.FC = () => {
  const navigate = useNavigate();

  const session = useAppSelector(getSession);
  const transactionStatus = useAppSelector(getTransactionStatus);
  const requestInfoType = useAppSelector(getRequestInfoType);

  const dispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(
      validateLegitimationResult({
        storefrontId: session?.id as string,
        token: session?.token as string,
        navigate
      })
    );
    // TODO: not yet sure if polling for LEGITIMATION_CONDUCTED status is needed, probably not and we can just assume file submission is a success
    // so that the user does not have to wait
    // if status check is needed uncomment the following and change the redirects based on status
    // so that LEGITIMATION_DIGITAL_CONDUCTED does not redirect to legitimation conducted page

    // let interval: NodeJS.Timeout;
    // if (!isDocumentsUploadNeeded) {
    //   interval = setInterval(() => {
    //     dispatch(
    //       validateLegitimationResult({
    //         storefrontId: session?.id as string,
    //         token: session?.token as string,
    //         navigate
    //       })
    //     );
    //   }, 5_000);
    // }
    //
    // return () => {
    //   if (interval) {
    //     clearInterval(interval);
    //   }
    // };
  }, []);

  React.useEffect(() => {
    if (
      transactionStatus &&
      [
        TransactionStatus.LEGITIMATION_DIGITAL_CONDUCTED,
        TransactionStatus.LEGITIMATION_CONDUCTED,
        TransactionStatus.ACCEPTED,
        TransactionStatus.CANCELED
      ].includes(transactionStatus)
    ) {
      navigate(routeByStatus(transactionStatus, { requestInfoType }));
    }
  }, [transactionStatus]);

  return (
    <ContentSection pageWrap>
      <Spinner fullPage></Spinner>
    </ContentSection>
  );
};
